import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useSnackbar } from "notistack";
import { UseOrders } from "../OrdersPage/UseOrders";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function SubmitButton(props) {
  const { updateOrder } = UseOrders();
  const { enqueueSnackbar } = useSnackbar();
  const [progress, setProgress] = useRecoilState(rsProgress);

  useEffect(() => {}, []);

  return props.address ? (
    <Button
      color="secondary"
      onClick={() => {
        var body = {
          OrderId: props.id,
          Items: [
            {
              FiledName: "provinceID",
              Value: props.Value.provinceID,
            },
            {
              FiledName: "cityID",
              Value: props.Value.cityID,
            },
            {
              FiledName: "neighbourhoodID",
              Value: "",
            },
          ],
        };

        var body2 = {
          OrderId: props.id,
          Items: [
            {
              FiledName: "provinceID",
              Value: props.Value.provinceID,
            },
            {
              FiledName: "cityID",
              Value: props.Value.cityID,
            },
            {
              FiledName: "neighbourhoodID",
              Value: props.Value.neighbourhoodID
                ? props.Value.neighbourhoodID
                : 0,
            },
          ],
        };
        if (!props.Value.provinceID) {
          enqueueSnackbar("لطفا استان را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        } else if (!props.Value.cityID) {
          enqueueSnackbar("لطفا شهر را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        } else if (
          !window.ENV.neighborhoodNotValidation &&
          props.Value.cityID == 1 &&
          !props.Value.neighbourhoodID
        ) {
          enqueueSnackbar("لطفا محله را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        } else {
          setProgress(true);
          updateOrder(
            props.Value.neighbourhoodID !== undefined ? body2 : body,
            (callback) => {
              props.callback();
            },
          );
        }
      }}
      sx={{ my: 3 }}
      variant="contained"
    >
      ثبت
    </Button>
  ) : (
    <Button
      color="secondary"
      onClick={() => {
        var body = {
          OrderId: props.id,
          Items: [
            {
              FiledName: props.FiledName,
              Value: props.Value,
            },
          ],
        };
        var body2 = {
          OrderId: props.id,
          Items: [
            {
              FiledName: props.FiledName1,
              Value: props.Value1,
            },
            {
              FiledName: props.FiledName2,
              Value: props.Value2,
            },
          ],
        };
        if (props.editInfo && !props.Value) {
          enqueueSnackbar("لطفا بازه ارسال را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        }
        if (props.fullName && !props.Value1 && props.name1) {
          enqueueSnackbar("لطفا " + [props.name1] + " را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        } else if (props.fullName && !props.Value2 && props.name2) {
          enqueueSnackbar("لطفا " + [props.name2] + " را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        }

        if (!props.fullName && !props.Value && props.name) {
          enqueueSnackbar("لطفا " + [props.name] + " را وارد کنید", {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          return;
        } else {
          setProgress(true);
          updateOrder(props.fullName ? body2 : body, (callback) => {
            props.callback();
          });
        }
      }}
      sx={{ my: 3 }}
      variant="contained"
    >
      ثبت
    </Button>
  );
}
